/* 2026-08-17 FIX. threshold was .15, which requires 15% of the ELEMENT'S OWN area to be
   inside the viewport. The legal document blocks are 2,810px (imprint), 3,792px
   (withdrawal), 5,807px (terms) and 8,239px (privacy) tall. 15% of those is 422, 569, 871
   and 1,236px. A ~720px viewport can satisfy the first two and can NEVER satisfy the last
   two, at any scroll position. Those blocks therefore never received .is-in and stayed at
   the opacity:0 set by [data-reveal] in ow2-motion.css, forever. Result: title and nav
   render, document body is invisible, in every locale, incognito included. Exactly the
   reported symptom, and it is why the short imprint page looked fine while privacy did not.

   threshold:0 fires as soon as any part of the element enters the viewport, so the trigger
   no longer depends on element height. The stagger and the reduced-motion path are
   unchanged.

   Second change: if IntersectionObserver is missing, reveal everything instead of leaving
   the page permanently blank. A motion enhancement must never be able to hide content.

   The sourceMappingURL comment was dropped: the committed .map no longer matches this file
   and a stale map is worse than none. */
(function () {
  "use strict";
  var nodes = document.querySelectorAll("[data-reveal]");
  if (!nodes.length) return;

  function showAll() {
    Array.prototype.forEach.call(nodes, function (n) { n.classList.add("is-in"); });
  }

  if (!("IntersectionObserver" in window)) { showAll(); return; }
  if (window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches) { showAll(); return; }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var i = parseInt(e.target.dataset.reveal, 10) || 1;
      e.target.style.transitionDelay = (i - 1) * 70 + "ms";
      e.target.classList.add("is-in");
      io.unobserve(e.target);
    });
  }, { threshold: 0 });

  Array.prototype.forEach.call(nodes, function (n) { io.observe(n); });
})();
